import { render, staticRenderFns } from "./sendDocumentOnMail.vue?vue&type=template&id=26c80ce4&scoped=true"
import script from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
export * from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendDocumentOnMail.vue?vue&type=style&index=1&id=26c80ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c80ce4",
  null
  
)

export default component.exports